// Admission.js
import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import Header from "../Header"; // Assuming Header component exists
import Footer from "../Footer"; // Assuming Footer component exists
import axios from "axios";

const Admission = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    dateOfBirth: "",
    fatherName: "",
    motherName: "",
    address: "",
    mobileNumber: "",
    admittingClass: "",
    currentSchoolName: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("http://localhost:5000/admission-enquiry", formData);
      setIsSubmitted(true); // Show thank-you message after successful submission
    } catch (err) {
      console.error("Failed to submit admission:", err);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Box
        sx={{
          flex: 1,
          padding: { xs: "16px", sm: "32px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
        }}
      >
        {!isSubmitted ? (
          <>
            <Typography variant="h4" gutterBottom>
              Admission Enquiry
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                width: { xs: "100%", sm: "75%", md: "50%" },
                backgroundColor: "#ffffff",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <TextField
                label="Student Name"
                name="studentName"
                value={formData.studentName}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Date of Birth"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
              />
              <TextField
                label="Father's Name"
                name="fatherName"
                value={formData.fatherName}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Mother's Name"
                name="motherName"
                value={formData.motherName}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                fullWidth
                required
                multiline
              />
              <TextField
                label="Mobile Number"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                type="tel"
                fullWidth
                required
              />
              <TextField
                label="Admitting in Class"
                name="admittingClass"
                value={formData.admittingClass}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Current School Name"
                name="currentSchoolName"
                value={formData.currentSchoolName}
                onChange={handleChange}
                fullWidth
              />
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </Box>
          </>
        ) : (
          <Typography variant="h5" sx={{ textAlign: "center", marginTop: "32px" }}>
            Thank you for your request!
          </Typography>
        )}
      </Box>
      <Footer />
    </div>
  );
};

export default Admission;
